import { Cascader } from "antd";
import { BaseOptionType, SingleValueType } from "rc-cascader/lib/Cascader";

import * as theme from "./tagsCascader.css";
import { TagCascaderOption } from "./types";
interface TagsCascaderProps {
    placeholder?: string;
    options: TagCascaderOption[];
    onChange: (
        value: SingleValueType[],
        selectOptions: BaseOptionType[][]
    ) => void;
    value?: string[][] | null;
}

export function TagsCascader({
    placeholder,
    options,
    onChange,
    value,
}: TagsCascaderProps) {
    return (
        <div>
            <Cascader
                multiple
                showSearch
                autoFocus
                placeholder={placeholder}
                onChange={onChange}
                className={theme.cascader}
                displayRender={(value) => {
                    if (value.length === 1) {
                        return <b>{value[0]}</b>;
                    }

                    return (
                        <div>
                            <b>{value[0]}: </b>
                            {value[1]}
                        </div>
                    );
                }}
                options={options}
                value={value ?? undefined}
            />
        </div>
    );
}
